/* ==========================================================================
   SearcherPackagesFerry > Config
   ========================================================================== */

/* Modules */
const panelPassengerConfig = require('../../../ui-panel-passenger-ferry/client/js/config');
const panelVehicleConfig = require('../../../ui-panel-vehicle-ferry/client/js/config');

const configuration = {
    selector: '[data-component="SearcherFerryHotel"]',
    type: {
        select: 'select',
        calendar: 'calendar',
        uipanel: {
            passenger: {
                trigger: 'ui-panel-passenger-ferry-trigger',
                panel: panelPassengerConfig().type.panel
            },
            vehicle: {
                trigger: 'ui-panel-vehicle-ferry-trigger',
                panel: panelVehicleConfig().type.panel
            }
        },
        submit: 'submit'
    },
    css: {
        item: 'searcher__item',
        itemLarge: 'searcher__item--large',
        itemSmall: 'searcher__item--small',
        itemButton: 'searcher__item--button',
        button: 'searcher__button'
    },
    vehicle: {
        css: ['searcher__item', 'searcher__item--vehicle']
    },
    accommodationPanel: {
        css: 'ui-panel--accommodation-packages',
        type: 'ui-panel-passenger-ferry-hotel',
        selector: '[data-component="UiPanel"][data-type="ui-panel-passenger-ferry-hotel"]',
        hasClose: true,
        maxRooms: 4,
        adults: {
            min: 1,
            max: 6,
            value: 2
        },
        children: {
            min: 0,
            max: 5,
            value: 0,
            ages: {
                min: 0,
                max: 17
            }
        }
    },
    accommodationTrigger: {
        type: 'input-passenger-ferry-hotel-trigger',
        selector: '[data-component="Input"][data-type="input-passenger-ferry-hotel-trigger"]',
        icon: 'user'
    },
    submit: {
        url: '/ferriessaleprocess/FerryHotelAvailability'
    },
    image: {
        cdn: '//cdn.logitravel.com',
        src: '/comun/images/lineas/ferries_800x600.jpg',
        alternative: '/comun/images/lineas/viajes_800x600.jpg',
        resize: '/wsimgresize/resize/crop/334/260/',
        quality: '80'
    },
    disableDays: [
        '2020/05/25',
        '2020/05/26',
        '2020/05/27',
        '2020/05/28',
        '2020/05/29',
        '2020/05/30',
        '2020/05/31',
        '2020/06/01',
        '2020/06/02',
        '2020/06/03',
        '2020/06/04',
        '2020/06/05',
        '2020/06/06',
        '2020/06/07',
        '2020/06/08',
        '2020/06/09',
        '2020/06/10',
        '2020/06/11',
        '2020/06/12',
        '2020/06/13',
        '2020/06/14',
        '2020/06/15'
    ],
    getStyle: element => configuration[element].css,
    getType: element => configuration[element].type,
    getSelector: element => `${configuration.selector} ${configuration[element].selector}`
};

const config = () => configuration;

module.exports = config;
